<template>
  <!-- bg_white bg_gray  -->
  <div v-show="showTit === '大事提醒'">
    <p class="nothing-tips" v-if="notData">暂无数据</p>
    <section class="main" v-if="!notData">
      <hgroup class="mainPage xxtx">
        <header>大事提醒</header>
        <ul class="xxtx-timeLine">
          <li v-for="(item, index) in  listData" :key="index">
            <span class="time">{{item.REMINDERDATE_S.substr(5,5)}}<small>{{item.REMINDERDATE_S.substr(0,4)}}</small></span>
            <h6>{{item.REMINDERNAME}}</h6>
            <p>
              <strong>{{ item.REMINDERMEMO }}</strong>
            </p>
          </li>
        </ul>
      </hgroup>
    </section>
		<Loading v-show="loading"></Loading>
    <declare v-if="!notData"></declare>
  </div>
</template>

<script>
import { getEventData } from "../api/index";
import mixins from '../mixins/index';
import Loading from "../components/loading"
import Declare from "../components/declare"
export default {
  name: "brief",
  props: ["showTit", "token"],
  data() {
    return {
			loading: false,
			notData: false,
			listData: [],
			code: "",
    };
  },
  components:{Loading,Declare},
  mixins: [mixins],
  watch: {
    showTit: {
      handler(newval, old) {
        if (newval === "大事提醒" && this.listData.length <= 0) {
          this.code = this.getUrlQuery("code");
          this.$nextTick(() => {
            this.getAffairData();
          });
        }
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 获取事件提醒数据
    getAffairData: function () {
      let that = this;
			that.loading = true
      let eventKey = that.code + "-B1-2"; // 事件提醒更多页
      let busiTypeArr = [eventKey];
      let objs = {
        busiCode: window.config.busiCode,
        merId: window.config.merId,
        reqData: {
          busiType: busiTypeArr.join(),
          category: "hkf10",
        },
      };
      getEventData(JSON.stringify(objs), that.token)
        .then((res) => {
          if (res.resCode === "000000" && res.resData[res.resData.k]) {
						if(res.resData[res.resData.k].sjtxList.length > 0){
							that.listData = res.resData[res.resData.k].sjtxList;
						}
          }else{
						that.notData = true;
					}
					that.loading = false;
        })
        .catch(() => {
					that.notData = true;
					that.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped></style>
